import React, { type InputHTMLAttributes, useEffect, useState } from 'react';

import { Input } from '@pkg/components';
import { Wrapper } from '@pkg/components/DesignSystem';

import { usePrevious } from '@app/helpers';
interface Props extends InputHTMLAttributes<HTMLInputElement> {
    value: string | number | undefined;
    dirty?: boolean;
    hasErrorCheck: (string) => boolean | string;
    validEmoji?: string;
    invalidEmoji?: string;
    placeholder?: string;
    name?: string;
}
const ValidTextInput = ({
    value,
    dirty = false,
    onChange,
    hasErrorCheck,
    validEmoji = '✅',
    invalidEmoji = '⛔️',
    placeholder,
    name,
    ...rest
}: Props) => {
    const [hasError, setHasError] = useState<boolean | string>();
    const [dirtyState, setDirtyState] = useState(dirty);
    const prevValue = usePrevious(value);

    useEffect(() => {
        if (dirtyState && prevValue !== value && hasErrorCheck) {
            setHasError(hasErrorCheck(value));
        }
    }, [value, hasErrorCheck, dirtyState, prevValue]);

    const emojiString = dirtyState ? (hasError ? invalidEmoji : validEmoji) : undefined;
    return (
        <Wrapper gap="10px" margin=" 0 0 10px">
            <Input
                type="text"
                onChange={(e) => {
                    setDirtyState(true);
                    onChange?.(e);
                }}
                value={value}
                placeholder={placeholder}
                name={name}
                labelInside={emojiString}
                {...rest}
            />
        </Wrapper>
    );
};

export default ValidTextInput;
